import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import { getTimeZones } from '@vvo/tzdb';

dayjs.extend(utc)
dayjs.extend(timezone)

export const getFacilityName = (teamId, facilities) => {
  const facility = facilities.find(
    (facility) => facility.kpro_team_id === teamId
  )
  return facility ? facility.facility_name : 'N/A'
}

export const formatHL7Logs = (logs, facilities) => {
  return logs?.map((log) => ({
    ...log,
    kproTeamId:
      getFacilityName(log.kproTeamId, facilities || []) ||
      'N/A',
    facility_id: log.facility_id || 'N/A',
    order_number: log.order_number || 'N/A',
    message_id: log.message_id || 'N/A',
    createdAt: log.createdAt,
  }))
}

export const formatTimeRemaining = (startDateTime, endDateTime) => {
  if (endDateTime <= startDateTime) return '0s'
  const totalSeconds = dayjs(endDateTime).diff(
    dayjs(startDateTime),
    'seconds'
  )
  const days = Math.floor(totalSeconds / (24 * 3600))
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const parts = []
  if (days > 0) parts.push(`${days}d`)
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)
  if (seconds > 0) parts.push(`${seconds}s`)
  return parts.join(' ')
}

// Format date time to 'October 13, 2025 at 10:30 AM IST' (or user's local tz)

export const formatDateTime = (dateTime) => {
  if (!dateTime) return 'N/A';
  const date = new Date(dateTime);
  if (isNaN(date.getTime())) return 'N/A';
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formatted = new Intl.DateTimeFormat(
    typeof navigator !== 'undefined' ? navigator.language : 'en-US',
    {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      timeZone: tz
    }
  ).format(date);

  // Find abbreviation for user's IANA timezone using tzdb
  const tzInfo = getTimeZones().find(zone => zone.name === tz || zone.group.includes(tz));
  const abbr = tzInfo ? tzInfo.abbreviation : null;

  // If found, replace offset/name with abbreviation
  if (abbr) {
    // Remove offset or abbreviation at the end (e.g., 'GMT+5:30', 'IST', etc.)
    const cleaned = formatted.replace(/(\s?(GMT[+-]\d{1,2}:?\d{2}|[A-Z]{2,5}))$/, '');
    return cleaned.trim() + ' ' + abbr;
  }
  // Fallback: show formatted string as is
  return formatted;
};

